import { AxiosInstance, AxiosResponse } from 'axios';
import { TLocaleAPI, TLocaleISO } from '../types/locale';

// TODO - TYPES
export type TSubscriptionEndpoints = {
    createSchedule: (sku: string, data) => Promise<AxiosResponse<any>>;
    createSubscription: (sku: string, data) => Promise<AxiosResponse<any>>;
    deleteSubscriptionOneDayItem: (sku: string, data: any) => Promise<AxiosResponse<any>>;
    deleteSubscriptionItem: (sku: string) => Promise<AxiosResponse<any>>;
    getSubscriptionData: (sku: string) => Promise<AxiosResponse<any>>;
    getNextScheduleData: (sku: string) => Promise<AxiosResponse<any>>;
    getSubscriptions: (view: string, isPageSub?: boolean, month?: number | null) => Promise<AxiosResponse<any>>;
    getSubscriptionDeliverySlots: () => Promise<AxiosResponse<any>>;
    setSubscriptionPreferences: (data: any, isPageSub?: boolean) => Promise<AxiosResponse<any>>;
    setSubscriptionItemQuantity: (sku: string, data: any) => Promise<AxiosResponse<any>>;
    setSubscriptionPause: (data: any, isPageSub?: boolean) => Promise<AxiosResponse<any>>;
    deleteSubscriptionPause: (isPageSub?: boolean) => Promise<AxiosResponse<any>>;
};

export default (api: AxiosInstance, apiLocale: TLocaleAPI): TSubscriptionEndpoints => {
    const createSchedule = (sku: string, data): Promise<AxiosResponse<any>> =>
        api.post<any>(`/_svc/sub-v1/schedule/${sku}`, data, { headers: { 'x-locale': apiLocale } });

    const createSubscription = (sku: string, data): Promise<AxiosResponse<any>> =>
        api.post<any>(`/_svc/sub-v1/subscription/${sku}`, data, { headers: { 'x-locale': apiLocale } });

    const getSubscriptionData = async (sku: string): Promise<AxiosResponse<any>> =>
        api.get(`/_svc/sub-v1/subscription/${sku}`, { headers: { 'x-locale': apiLocale } });

    const getNextScheduleData = async (sku: string): Promise<AxiosResponse<any>> =>
        api.get(`/_svc/sub-v1/next-schedule/${sku}`, { headers: { 'x-locale': apiLocale } });

    const getSubscriptions = async (view: string, isPageSub?: boolean, month?: number): Promise<AxiosResponse<any>> =>
        api.get(
            `/_svc/sub-v1/subscription?view=${view}${month ? `&month=${month}` : ''}${
                isPageSub ? '&isPageSub=true' : ''
            }`,
            {
                headers: { 'x-locale': apiLocale },
            },
        );

    const deleteSubscriptionOneDayItem = (sku: string, data: any): Promise<AxiosResponse<any>> =>
        api.post<any>(`/_svc/sub-v1/schedule/${sku}`, data, {
            headers: { 'x-locale': apiLocale, 'X-HTTP-Method-Override': 'DELETE' },
        });

    const deleteSubscriptionItem = (sku: string): Promise<AxiosResponse<any>> =>
        api.delete<any>(`/_svc/sub-v1/subscription/${sku}`, { headers: { 'x-locale': apiLocale } });

    const getSubscriptionDeliverySlots = (): Promise<AxiosResponse<any>> =>
        api.get<any>(`/_svc/sub-v1/subscription/delivery-time-slots`, { headers: { 'x-locale': apiLocale } });

    const setSubscriptionPreferences = (data: any, isPageSub = true) =>
        api.post<any>(`/_svc/sub-v1/subscription/customer-preference${isPageSub ? '?isPageSub=true' : ''}`, data, {
            headers: { 'x-locale': apiLocale },
        });

    const setSubscriptionItemQuantity = (sku: string, data: any): Promise<AxiosResponse<any>> =>
        api.put<any>(`/_svc/sub-v1/schedule/${sku}`, data, { headers: { 'x-locale': apiLocale } });

    const setSubscriptionPause = (data: any, isPageSub = true) =>
        api.post<any>(`/_svc/sub-v1/subscription/pause${isPageSub ? '?isPageSub=true' : ''}`, data, {
            headers: { 'x-locale': apiLocale },
        });
    const deleteSubscriptionPause = (isPageSub = true) =>
        api.delete(`/_svc/sub-v1/subscription/pause?${isPageSub ? '?isPageSub=true' : ''}`, {
            headers: { 'x-locale': apiLocale },
        });
    return {
        createSchedule,
        createSubscription,
        deleteSubscriptionOneDayItem,
        deleteSubscriptionItem,
        getSubscriptionData,
        getNextScheduleData,
        getSubscriptions,
        getSubscriptionDeliverySlots,
        setSubscriptionPreferences,
        setSubscriptionItemQuantity,
        setSubscriptionPause,
        deleteSubscriptionPause,
    };
};
